import axios, { AxiosInstance, AxiosRequestConfig } from "axios";
import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig } from "../auth/authConfig";

interface BaseConfig extends AxiosRequestConfig {
  baseURL: string;
}

const baseConfig: BaseConfig = {
  baseURL: process.env.REACT_APP_API_URL as string,
};

const msalInstance = new PublicClientApplication(msalConfig);

const initializeMsalInstance = async () => {
  try {
    await msalInstance.initialize(); // Ensures the MSAL instance is fully initialized
  } catch (error) {
    console.error("Failed to initialize MSAL instance:", error);
  }
};

const createService = (useAuth: boolean): AxiosInstance => {
  const instance: AxiosInstance = axios.create(baseConfig);
  instance.defaults.headers.common["Content-Type"] = "application/json";

  if (useAuth) {
    instance.interceptors.request.use(
      async (config) => {
        try {
          await initializeMsalInstance();

          const activeAccount = msalInstance.getActiveAccount();
          if (!activeAccount) {
            console.error("No active account found. User needs to log in.");
            return config;
          }

          const tokenResponse = await msalInstance.acquireTokenSilent({
            scopes: [ process.env.REACT_APP_MSAL_SCOPE as string], 
            account: activeAccount,
          });

          if (tokenResponse && tokenResponse.accessToken) {
            config.headers.Authorization = `Bearer ${tokenResponse.accessToken}`;
          }
        } catch (error) {
          console.error("Failed to acquire token silently:", error);
        }
        return config;
      },
      (error) => {
        return Promise.reject(error);
      }
    );
  }

  return instance;
};

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  service: createService,
};